export const PET_MENU_PATHS = ['/pets/care', '/pets/archive', '/pets/records', '/pets/loss'];
export function normalizeNavigationPath(path) { return path === '/pets' ? '/pets/care' : path; }

export const CASHIER_ORDER = ['cashier', 'order', 'refund', 'shift', 'desk', 'desk-area', 'desk-manage'];
export const MENU_GROUP_ORDER = ['工作台', '收银交易', '萌宠管理', '营销中心', '会员管理', '预约服务', '商品管理', '库存管理', '员工中心', '财务中心', '系统设置'];

export function sortMenuItems(items, group) {
  const order = group === '工作台' ? ['dashboard'] : group === '收银交易' ? CASHIER_ORDER : group === '萌宠管理' ? PET_MENU_PATHS.map((path) => path.slice(1)) : [];
  const rank = (path) => order.includes(path) ? order.indexOf(path) : 99;
  return items.slice().sort((a, b) => rank(a.path) - rank(b.path));
}

export function sanitizeFavorites(paths, availablePaths) {
  return Array.isArray(paths)
    ? [...new Set(paths.map(normalizeNavigationPath).filter((path) => typeof path === 'string' && availablePaths.includes(path)))].slice(0, 50)
    : [];
}

export function reconcileTabs(tabs, availablePaths, current) {
  const result = [];
  const add = (tab) => {
    const path = tab && normalizeNavigationPath(tab.path);
    if (path && availablePaths.includes(path) && !result.some((item) => item.path === path)) {
      const fullPath = typeof tab.fullPath === 'string' && tab.fullPath.split(/[?#]/)[0] === tab.path
        ? path + tab.fullPath.slice(tab.path.length) : path;
      result.push({ path, fullPath });
    }
  };
  if (availablePaths.includes('/cashier')) add({ path: '/cashier' });
  if (Array.isArray(tabs)) tabs.forEach(add);
  add(current);
  return result;
}
